import chevronTable from '../../../../../assets/icons/chevronTable.svg';
import InvestifyWTAC from '../../../../../assets/icons/InvestifyWTAC.svg';
import { formatToNaira } from '../../../../../helpers/utils';
import { IpoOfferListProps } from '../../../../../types';

const IpoOfferList = ({ items, onItemClick }: IpoOfferListProps) => (
  <div className="ipo-offer-list">
    {items.map((item) => (
      <div key={item.offerId} className="ipo-offer-list__item pointer" onClick={() => onItemClick(item)}>
        <img
          src={item.image || InvestifyWTAC}
          className="ipo-offer-list__item-image"
          alt=""
          onError={(e) => {
            e.currentTarget.src = InvestifyWTAC;
          }}
        />
        <div className="ipo-offer-list__item-details">
          <h3>{item.offerName}</h3>
          <span>{item.offerId}</span>
        </div>
        <div className="ipo-offer-list__item-returns">
          <h4>{formatToNaira(item.totalAmount)}</h4>
          <div>
            <span>{item.subscriptionCount}</span>{' '}
            <span>{item.subscriptionCount === 1 ? 'subscription' : 'subscriptions'}</span>
          </div>
        </div>
        <img className="chevron-table" src={chevronTable} alt="" />
      </div>
    ))}
  </div>
);

export default IpoOfferList;
